import React from 'react';
import { Alert, CircularProgress } from '@mui/material';

/**
 * Where a document stands in SAP: being sent, in SAP (or waiting there for finance), or refused with SAP's
 * reason. `action` is the retry button, shown with a refusal.
 */
const SapLine: React.FC<{
  status: 'Posting' | 'Posted' | 'Failed' | 'Waiting' | null | undefined;
  children: React.ReactNode;
  error?: string | null;
  action?: React.ReactNode;
}> = ({ status, children, error, action }) => {
  if (!status) return null;
  if (status === 'Failed') {
    return (
      <Alert severity="error" action={action} sx={{ whiteSpace: 'pre-line' }}>
        {children}
        {error ? `: ${error}` : ''}
      </Alert>
    );
  }
  if (status === 'Posting') return <Alert severity="info" icon={<CircularProgress size={18} />}>{children}</Alert>;
  if (status === 'Waiting') return <Alert severity="warning" action={action}>{children}</Alert>;
  return <Alert severity="success" action={action}>{children}</Alert>;
};

export default SapLine;
